import React from 'react';
import type { PopupHeaderProps } from './types';
import { isImageIconUrl } from '@/utils/iconRenderer';
import styles from './PopupHeader.module.css';

export function PopupHeader({ icon, name, tagline, signatureColor }: PopupHeaderProps) {
  const isImage = isImageIconUrl(icon);

  return (
    <div className={styles.header}>
      {/* Game Icon - supports both image paths and text/emoji */}
      <div
        className={styles.iconContainer}
        style={{
          backgroundColor: isImage ? 'transparent' : signatureColor,
          boxShadow: isImage ? 'none' : `0 8px 24px ${signatureColor}33`
        }}
      >
        {isImage ? (
          <img
            src={icon}
            alt={name}
            className={styles.iconImage}
          />
        ) : (
          <span className={styles.iconText}>
            {icon}
          </span>
        )}
      </div>
      
      {/* Game Info */}
      <div className={styles.info}>
        <h1
          className={styles.title}
          style={{ color: signatureColor, WebkitTextFillColor: signatureColor }}
        >
          {name}
        </h1>
        <p className={styles.tagline}>
          {tagline}
        </p>
      </div>
    </div>
  );
}